module.exports = __webpack_public_path__ + "static/media/close.0aa2678e.svg";